<script lang="ts">
	import { goto } from '$app/navigation';
	import { isDarkMode } from '$lib/stores/dark-mode';
	import WidgetTitle from '$lib/widget/components/WidgetTitle.svelte';
	import { classesDependingOnProfile, type WidgetColorProfile } from '$lib/widget/helper/widget';
	import { widgetColors, widgetConfig, widgetContent } from '$lib/widget/stores';
	import { fade } from 'svelte/transition';

	interface Props {
		preview?: boolean;
	}
	let { preview = false }: Props = $props();

	function getTitleClasses(theme: WidgetColorProfile, isDarkMode: boolean) {
		return classesDependingOnProfile(
			theme.inversedHeaderTextColor ? 'invert' : '',
			theme.dark.inversedHeaderTextColor ? 'dark:invert' : ''
		);
	}

	let businessInfo = $derived($widgetContent.business ?? null);

	let hasHeader = $derived(
		$widgetColors.showLogo || $widgetColors.showBusinessName || $widgetColors.banner
	);
	let style = $derived(
		$widgetColors.banner
			? `background-image: url(${$widgetColors.banner}); background-size: cover;`
			: ''
	);
	let backgroundClasses = $derived($widgetColors.banner ? 'bg-cover bg-center' : '');
	let titleClasses = $derived(getTitleClasses($widgetColors, $isDarkMode));
</script>

{#if hasHeader && businessInfo}
	<button
		class="items-center flex flex-col gap-5 p-5 min-h-32 flex-none justify-center {backgroundClasses} {preview
			? 'cursor-default'
			: ''}"
		{style}
		transition:fade={{ duration: 300 }}
		onclick={() => {
			if (!preview) goto('/widget/' + $widgetConfig.hash);
		}}
	>
		{#if $widgetColors.showLogo && businessInfo.logo}
			<img src={businessInfo.logo} alt={businessInfo.name} class="lg:h-32 h-12 max-w-96" />
		{/if}
		{#if $widgetColors.showBusinessName}
			<WidgetTitle level="1" className="font-semibold {titleClasses}">
				{businessInfo.name}
			</WidgetTitle>
		{/if}
	</button>
{/if}
